import React, { useRef } from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import AttachFileRoundedIcon from "@mui/icons-material/AttachFileRounded";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import ActionButton from "../../../component/common/ActionButton";
import { formatFileSize } from "../../../util/numberFormat";
import { ds } from "../../../styles/designSystem";

const C = ds.colors;

/**
 * 업로드 대기 파일 선택기 — 아직 서버로 안 보낸 파일들.
 *
 * <p>요청 등록·새 버전 등록이 모두 "파일 여러 개를 고르고 한 번에 전송" 이라 공통으로 쓴다.
 * 같은 파일을 두 번 고르면 중복 전송되므로 (name, size) 로 걸러낸다.
 */
export default function PendingFileList({ files = [], onChange, label = "파일 선택", helper, sx }) {
    const inputRef = useRef(null);

    const add = (picked) => {
        const seen = new Set(files.map(f => `${f.name}:${f.size}`));
        const next = [...files];
        for (const f of picked) {
            const key = `${f.name}:${f.size}`;
            if (!seen.has(key)) { seen.add(key); next.push(f); }
        }
        onChange(next);
    };

    return (
        <Box sx={sx}>
            <input
                ref={inputRef}
                type="file"
                multiple
                hidden
                onChange={(e) => {
                    add(Array.from(e.target.files || []));
                    e.target.value = "";     // 같은 파일 재선택이 가능하도록 초기화
                }}
            />
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: files.length ? 1 : 0 }}>
                <ActionButton
                    variant="secondary"
                    size="small"
                    startIcon={<AttachFileRoundedIcon sx={{ fontSize: 16 }} />}
                    onClick={() => inputRef.current?.click()}
                >
                    {label}
                </ActionButton>
                {helper && (
                    <Typography sx={{ fontSize: 11.5, color: C.textMuted }}>{helper}</Typography>
                )}
            </Stack>
            {files.length > 0 && (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                    {files.map((f, i) => (
                        <Chip
                            key={`${f.name}-${f.size}-${i}`}
                            icon={<InsertDriveFileRoundedIcon sx={{ fontSize: 14 }} />}
                            label={`${f.name} (${formatFileSize(f.size)})`}
                            size="small"
                            onDelete={() => onChange(files.filter((_, idx) => idx !== i))}
                            sx={{ maxWidth: 280, fontSize: 11.5, bgcolor: "#f1f5f9", border: `1px solid ${C.border}` }}
                        />
                    ))}
                </Box>
            )}
        </Box>
    );
}
